import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Mental} from "../Mental";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {WinRatioType} from "../../framework/winPresentation/IWinRatios";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {SoundManager} from "../sound/SoundManager";
import {MentalSoundConfig} from "../MentalSoundConfig";

export class MentalBigWinAnticipationView extends PIXI.Container implements StageLayer {
    private static leftAnimation: TimelineSprite;
    private static rightAnimation: TimelineSprite;

    public static createItems(): void {
        const yPos: number = 395,
            xOffset: number = 50,
            layer: StageLayer = NolimitApplication.getLayerByName(Mental.LAYERS.BIG_WIN_ANTICIPATION)!;

        this.leftAnimation = new TimelineSprite(Mental.assetLoader.getTextures("bigWinAnticipation"));
        this.leftAnimation.hide();
        this.leftAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this.leftAnimation.scale.set(2);
        this.leftAnimation.anchor.set(0.5);
        this.leftAnimation.position.set(360 + this.leftAnimation.width / 2 - xOffset, yPos);

        this.rightAnimation = new TimelineSprite(Mental.assetLoader.getTextures("bigWinAnticipation"));
        this.rightAnimation.hide();
        this.rightAnimation.blendMode = PIXI.BLEND_MODES.ADD;
        this.rightAnimation.scale.set(-2, 2);
        this.rightAnimation.anchor.set(0.5);
        this.rightAnimation.position.set(360 - this.rightAnimation.width / 2 + xOffset, yPos);

        layer.addChild(this.leftAnimation, this.rightAnimation);
    }

    public static playBigWinAnticipation(): void {
        Mental.background.playWinFlickerAnim(WinRatioType.LARGE, -1);

        this.leftAnimation.show();
        this.leftAnimation.playLoop();

        this.rightAnimation.show();
        this.rightAnimation.playLoop();

        SoundManager.playSoundEffect(MentalSoundConfig.ANTICIPATION_DEFAULT, 0, 1);
    }

    public static stopBigWinAnticipation(): void {
        Mental.background.stopWinFlicker();

        this.leftAnimation.stopLoop();
        this.leftAnimation.hide();

        this.rightAnimation.stopLoop();
        this.rightAnimation.hide();

        SoundManager.fadeSound(MentalSoundConfig.ANTICIPATION_DEFAULT, 1, 0, 0.3);

        SoundManager.playSoundEffect(MentalSoundConfig.ANTICIPATION_DEFAULT_END);
    }
}
